module.exports = __webpack_public_path__ + "static/img/success2.30d98667.png";